import { useEffect, useState } from 'react';
import { HiOutlineInformationCircle } from 'react-icons/hi';
import Message from '../../../components/toast-message';
import Loader from '../../../components/form-loader/form-loader';
import { useAppInfo } from '../../../helpers/hooks/common-hook';
import { getByAppId } from '../../../services/app/app-service';
import TextBox from '../../../components/forms/text-box';
import TextArea from '../../../components/forms/text-area';
import SettingsPage, { SettingsSection } from '../components/settings-layout';

export default function GeneralSettings() {
  const { appId } = useAppInfo();
  const [app, setApp] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(false);
    getByAppId(appId).then(response => {
      if (active) {
        setApp(response);
        setError(!response);
        setLoading(false);
      }
    });
    return () => { active = false; };
  }, [appId]);

  return <SettingsPage navigationPosition="below-header" title="General settings" subtitle="Your application's identity and essential information.">
    {loading ? <Loader /> : error ? <Message text="Unable to load application information. Please refresh to try again." type="error" /> :
      <div className="grid items-start gap-6 lg:grid-cols-[minmax(0,2fr)_minmax(0,1fr)]">
        <SettingsSection title="Application details" description="The name and description associated with this application.">
          <TextBox label="Application name" id="app-name" value={app?.name || ''} readOnly />
          <TextArea label="Description" id="app-description" value={app?.description || ''} placeholder="No description provided" readOnly rows={4} />
          <p className="text-xs text-gray-500">Application details are read-only on this page.</p>
        </SettingsSection>
        <SettingsSection title="Application reference" description="Use this identifier when working with integrations.">
          <TextBox label="Application ID" id="app-id" value={appId || ''} readOnly />
          <div className="flex items-start gap-3 rounded-xl bg-gray-50 p-4 text-sm leading-6 text-gray-500">
            <HiOutlineInformationCircle className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" />
            <p>Use the tabs above to configure models, agent behavior, voice, and access keys.</p>
          </div>
        </SettingsSection>
      </div>}
  </SettingsPage>;
}
